/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import { hot } from 'react-hot-loader/root'
import { Waypoint } from 'react-waypoint'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { GraphicWeek } from '../graphicweek'
import { GraphicMonth } from '../graphicmonth'
import { GraphicHalfyear } from '../graphichalfyear'
import { GraphicYear } from '../graphicyear'
import { GraphicTenYears } from '../graphictenyears'
import { GraphicLife } from '../graphiclife'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { ArticleTeasers, sortMode } from '@ta-interaktiv/react-article-teasers'

// TODO Set the correct article ID here
const ARTICLE_ID = '16800014'
const isMobile = window.innerWidth < 769

let baseUrl = window.location.hostname.replace('interaktiv.', '')
baseUrl = baseUrl.replace('.ch', '')
baseUrl.replace(new RegExp('.', 'g'), '')

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.isMobile = window.innerWidth < 600
    this.isTablet = window.innerWidth < 1025
  }

  render() {
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} />
        <ThemeSwitch />

        {/* TODO Replace the following segment with your project cover */}
        <header className='ui vertical segment'>
          <div className='ui container'>
            <h1 className='ui header'>
              Tout ce plastique que nous mangeons
            </h1>

            <h2 className='ui header'>
              <div className='small sub header'>
                Les microplastiques sont partout, même dans notre alimentation. La masse
                de plastique passant dans notre corps n’est guère négligeable. Quelles
                quantités ingurgitons-nous involontairement? Cette consommation est-elle
                dangereuse?
              </div>
            </h2>
          </div>
        </header>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: 'startReading'
              })
            }
          }}
        />

        <div className='content'>
          <div className='ui container'>
              <GraphicWeek />
          </div>
          <div className='ui text container'>
            <p>
              Jour après jour, nous mangeons, buvons et respirons du plastique. Selon
              les relevés de <a href='https://wwf.panda.org/wwf_news/press_releases/?348337/Revealed-plastic-ingestion-by-people-could-be-equating-to-a-credit-card-a-week'>l’Université australienne de Newcastle effectués à la demande
              du WWF</a>, chaque être humain en consomme chaque semaine sans le savoir quelques
              2000 minuscules particules. Ce qui correspond environ à 5 grammes – le poids
              d’une carte de crédit ou d’un bouchon de bouteille en plastique. Broyée, cela
              remplirait une cuiller à soupe. <a href='https://graphics.reuters.com/'>Reuters Graphics</a> a extrapolé ces quantités sur
              la durée d’une vie humaine et les a visualisées en photos.
            </p>
            <p>
              Car le plastique n’est pas biodégradable. Sous l’influence des éléments
              naturels, il se désintègre en éclats toujours plus petits, qui finissent
              par se disperser en tous lieux: en mer, sur les glaciers arctiques, en
              montagne. Les chercheurs ont trouvé du microplastique aux endroits les
              plus reculés. De taille inférieure à 5 millimètres, ces particules sont
              transportées par l’eau dans l’atmosphère et parcourent de grandes distances.
            </p>
            <p>
              En se nourrissant, tant la faune océanique que les insectes et animaux
              terrestres avalent de minuscules particules non solubles sans s’en rendre
              compte. Et les hommes finissent par manger ces animaux. En outre, des grains
              imperceptibles s’introduisent dans notre corps par l’intermédiaire des
              cosmétiques, des emballages plastiques de certains aliments ou de la vaisselle
              synthétique. L’eau potable, principalement celle des bouteilles en PET, est
              ainsi la plus grande source d’ingestion de plastique.
            </p>
          </div>
          <div className='ui container'>
              <GraphicMonth />
          </div>
          <div className='ui text container'>
            <p>
              Chaque mois, nous avalons 21 grammes de microplastique en nous
              alimentant. Cela correspond au poids de cinq dés à jouer et remplit
              un demi-bol à soupe.
            </p>
          </div>
          <Waypoint
            onEnter={event => {
              if (
                event.previousPosition === Waypoint.below &&
                event.currentPosition === Waypoint.inside
              ) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: '25ContentRead'
                })
              }
            }}
          />
          <div className='ui container'>
              <GraphicHalfyear />
          </div>
          <div className='ui text container'>
            <p>
              En un semestre, un être humain boit et mange en moyenne 125 grammes de plastique. Ce
              qui remplit un grand bol à dessert.
            </p>
          </div>
          <div className='ui container'>
            <GraphicYear />
          </div>
          <div className='ui text container'>
            <p>
              En une année, notre corps absorbe en se nourrissant une assiette entière de microplastique.
            </p>
          </div>
          <Waypoint
            onEnter={event => {
              if (
                event.previousPosition === Waypoint.below &&
                event.currentPosition === Waypoint.inside
              ) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: '50ContentRead'
                })
              }
            }}
          />
          <div className='ui container'>
            <GraphicTenYears />
          </div>
          <div className='ui text container'>
            <p>
              En dix ans – on n’en croit à peine ses yeux – nous mangeons l’équivalent
              d’une bouée de sauvetage entière, qui pèse 2,5 kilogrammes.
            </p>
          </div>
          <div className='ui container'>
            <GraphicLife />
          </div>
          <Waypoint
            onEnter={event => {
              if (
                event.previousPosition === Waypoint.below &&
                event.currentPosition === Waypoint.inside
              ) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: '75ContentRead'
                })
              }
            }}
          />
          <div className='ui text container'>
            <p>
            En moyenne globale, les humains atteignent 79 ans. En admettant que la situation en matière de microplastiques va ni s’améliorer, ni se dégrader, nous mangeons durant cette période 20 kilogramme de particules indigérables. Le poids de deux grosses poubelles en plastique.
            </p>
            <p>
            Et encore, il ne s’agit que d’une estimation prudente. Car la production mondiale de plastique ne cesse d’augmenter. En 2016, les usines du monde entier ont produit 396 millions de tonnes de matières synthétiques neuves. Deux cents fois plus qu’en 1950. Selon le WWF, un tiers de cette production finit dans l’environnement. Jusqu’en 2030, la production de plastique pourrait croître de 40%.
            </p>
            <AutofitIFrame
              aria-label='Interactive line chart'
              src='//datawrapper.dwcdn.net/yxK9e'
              height={this.isTablet ? (this.isMobile ? '415' : '550') : '550'}
              width='581'
              style={{ paddingTop: '1em', paddingBottom: '1em' }}
            />
          </div>
          <div className='ui text container'>
            <p>
              Dans quelle mesure ce microplastique est-il dangereux pour nous? La question
              est controversée, car les conséquences à long terme sur notre organisme
              n’ont pas encore été étudiées à ce jour. Selon <a href='https://apps.who.int/iris/bitstream/handle/10665/326499/9789241516198-eng.pdf?ua=1'>un rapport</a> de l’Organisation
              mondiale de la santé (OMS), l’ensemble des informations disponibles actuellement
              montre que la concentration de microplastique présente dans l’eau potable ne
              représente guère de dangers. Des mécanismes corporels veillent à ce que des
              petites particules soient éliminées par notre organisme. Mais il faudrait
              encore de nombreuses études pour traquer les implications possibles au niveau
              de la santé. 
            </p>
            <p>
              Le chimiste EPF Bernhard Wehrli partage cet avis. «D’un point de vue toxicologique, nous
              n’en savons pas assez sur les effets réels. Il y a beaucoup de spéculation à ce
              propos», déclare-t-il dans <a href='https://www.tagesanzeiger.ch/leben/gesellschaft/herr-professor-wie-gefaehrlich-ist-mikroplastik-im-darm/story/15105991'>notre interview</a>. «Je pars de l’idée que le microplastique
              n’est pas dangereux pour nous. Il est résistant à l’acidité gastrique, ne se dissout
              donc pas lorsqu’il passe par notre tube digestif».
            </p>
            <div className='ta quote'>
              <h3 className="ui small header">
              «Il y a des signes indiquant que le microplastique peut endommager le tractus gastro-intestinal.»
              </h3>
              <span className='quoteLabel'>
              Philipp Schwabl, auteur principal de <a href='https://www.umweltbundesamt.at/fileadmin/site/presse/news_2019/190606_BfR%20Verbraucherforum%20Mikroplastik%20LiebmannB.pdf'>l’étude pilote</a> de l’Université médicale de Vienne sur le microplastique dans les système digestif.
              </span>
            </div>
            <p>
              Pour les chercheurs autrichiens qui ont détecté du plastique dans les selles des
              participants à l’étude, il faudra des investigations complémentaires pour estimer
              les effets du microplastique sur l’homme. Dans leur <a href='https://www.tagesanzeiger.ch/wissen/medizin-und-psychologie/forscher-finden-plastik-im-stuhl-saemtlicher-probanden/story/11975983'>essai pilote</a>, ils relèvent
              toutefois «des signes que les microplastiques peuvent nuire au système
              gastro-intestinal en favorisant des réactions inflammatoires ou l’absorption
              d’impuretés dangereuses».
            </p>
            <p>
              En Suisse, l’assiette de microplastique ne semble pas être aussi pleine
              que celle estimé en perspective mondiale. L’institut de recherche sur les
              matériaux EMPA à Dübendorf estime que chez nous, quelques 5000 tonnes de
              plastique, autrement dit 630 grammes par habitant et par an, finissent dans
              l’environnement. Une partie, seulement 12%, est faite de microplastique. Cette
              quantité réduite en comparaison d’autres États s’explique par un système
              de récupération des déchets performant sans décharges sauvages. «Rien que la
              probabilité d’une toxicité accrue devrait nous faire réfléchir», estime Thava
              Palanisami de l’Université de Newcastle, qui a collaboré à cette récente étude.
            </p>
          </div>
        </div>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: 'contentBottom'
              })
            }
          }}
        />

        {/* TODO Add your credits in this component */}
        <Footer
          mailTo='mathieu.rudaz@tamedia.ch'
          hidePortfolioTeaser
          locale='fr'
          articleId={ARTICLE_ID}
          credits={[
            [
              'Données',
              '<a href="https://www.newcastle.edu.au/newsroom/featured/plastic-ingestion-by-people-could-be-equating-to-a-credit-card-a-week">University of Newcastle</a>, Australie; <a href="https://wwf.panda.org/wwf_news/press_releases/?348337/Revealed-plastic-ingestion-by-people-could-be-equating-to-a-credit-card-a-week">WWF</a>'
            ],
            [
              'Photos',
              'Anand Katakam et Simon Scarr, <a href="https://graphics.reuters.com">Reuters Graphics</a>'
            ],
            ['Texte', 'Yannick Wiget'],
            ['Conception', 'Mathias Lutz'],
            ['Adaptation pour la Suisse romande', 'Mathieu Rudaz'],
            ['Traduction', 'Laurent Duvanel']
          ]}
        >
          <div
            className='ui container'
            style={{ margin: isMobile ? '1.2em 0 3em' : '0 0 3em' }}
          >
            <h4 className='teaser'>Plus d'articles sur ce thème</h4>
            <ArticleTeasers
              sorting='reverse chronologically by creation date'
              numberOfCards='three'
              articleIds={[31901644, 24472045, 28352117]}
            />
          </div>
        </Footer>

        <Waypoint
          onEnter={event => {
            if (
              event.previousPosition === Waypoint.below &&
              event.currentPosition === Waypoint.inside
            ) {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                event: 'Interactions',
                event_action: 'vertical-scroll',
                event_label: 'pageBottom'
              })
            }
          }}
        />
      </div>
    )
  }
}

export default hot('AppComponent')
